import React from 'react';

function Term() {
    return (
        <div id="term" className="pd--100-0">
            <div className="container">

                <div className="section--content text-left">
                    <h2>Título Termo</h2>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend.</p>
                </div>

            </div>
        </div>
    );
}

export default Term;